import React from 'react';

export default function SyncIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12C4 7.58 7.58 4 12 4C14.8 4 17.27 5.39 18.74 7.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M20 12C20 16.42 16.42 20 12 20C9.2 20 6.73 18.61 5.26 16.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M16 7.5H19V4.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 16.5H5V19.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
